export default __webpack_public_path__ + "static/media/delete.7906479a.svg";